module.exports = __webpack_public_path__ + "static/media/img-block-2.8adc3a5e.png";